export default function VoiceVisualizer({
    isRecording,
    isPlayingAudio,
    audioLevel,
    recordingTime,
    theme
}) {
    const scale = isRecording ? 1 + audioLevel * 1.5 : isPlayingAudio ? 1.1 : 1;
    const opacity = isRecording ? 0.2 + audioLevel * 0.8 : isPlayingAudio ? 0.9 : 0.8;

    const styles = {
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "24px",
        },
        waveform: {
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: isPlayingAudio
                ? `radial-gradient(circle, ${theme.buttonBg}40, transparent)`
                : isRecording
                    ? `radial-gradient(circle, ${theme.buttonBg}60, ${theme.buttonBg}20)`
                    : `radial-gradient(circle, ${theme.buttonBg}30, transparent)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: `scale(${scale})`,
            opacity: opacity,
            transition: isRecording ? "all 0.1s ease-out" : "all 0.3s ease-out",
            position: "relative",
        },
        innerCircle: {
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: isPlayingAudio
                ? `linear-gradient(135deg, ${theme.buttonBg}, ${theme.buttonBg}CC)`
                : isRecording
                    ? `linear-gradient(135deg, ${theme.buttonBg}, ${theme.buttonBg}DD)`
                    : theme.buttonBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: isRecording || isPlayingAudio
                ? `0 0 20px ${theme.buttonBg}80`
                : "none",
        },
        timer: {
            fontSize: "14px",
            color: theme.text,
            opacity: 0.7,
            marginTop: "12px",
            fontVariantNumeric: "tabular-nums",
        },
    };

    return (
        <>
            <style>{`
                @keyframes breathe {
                    0%, 100% { opacity: 0.6; }
                    50% { opacity: 1; }
                }
            `}</style>
            <div style={styles.container}>
                <div style={styles.waveform}>
                    <div style={{
                        ...styles.innerCircle,
                        animation: isPlayingAudio ? "breathe 1.5s ease-in-out infinite" : "none",
                    }} />
                </div>
                {isRecording && (
                    <div style={styles.timer}>
                        {recordingTime}s / 60s
                    </div>
                )}
            </div>
        </>
    );
}
